var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("Generic case activity details component")]),_vm._v(" Raw Result Data: "),_c('pre',[_vm._v(_vm._s(_vm.caseActivityDetails.result_data))])])
}
var staticRenderFns = []

export { render, staticRenderFns }